import { useSpring, animated } from '@react-spring/web';
import classNames from 'classnames';
import { isValidElement, ReactNode } from 'react';

import CallToAction from '../partials/CallToAction';
import Image from '../partials/Image';
import PromotionDescription from '../typography/PromotionDescription';
import PromotionTitle from '../typography/PromotionTitle';

import styles from '../../styles/cards/promotion-card.module.css';

interface PromotionCardProps extends Partial<Omit<Promotion, 'callToAction'>> {
    callToAction?: CallToAction | ReactNode | null;
    theme?: string | null;
    withTransition?: boolean;
    invert?: boolean;
    children?: ReactNode | null;
    className?: string | null;
    innerClassName?: string | null;
    imageClassName?: string | null;
    pictureClassName?: string | null;
    contentClassName?: string | null;
    titleClassName?: string | null;
    descriptionClassName?: string | null;
    callToActionClassName?: string | null;
}
function PromotionCard({
    image = null,
    url = null,
    title = null,
    description = null,
    theme = null,
    callToAction = null,
    withTransition = false,
    invert = false,
    children = null,
    className = null,
    innerClassName = null,
    imageClassName = null,
    pictureClassName = null,
    contentClassName = null,
    titleClassName = null,
    descriptionClassName = null,
    callToActionClassName = null,
}: PromotionCardProps) {
    // const containerSpringRef = useSpringRef();
    const containerSpring = useSpring({
        // ref: containerSpringRef,
        from: {
            scale: 0,
        },
        to: {
            scale: 1,
        },
    });
    const label = (
        <>
            {title !== null ? (
                <PromotionTitle
                    className={classNames([styles.title, titleClassName])}
                    html={title}
                />
            ) : null}
            {description !== null ? (
                <PromotionDescription
                    className={classNames([styles.description, descriptionClassName])}
                    html={description}
                />
            ) : null}
        </>
    );
    const imageElement =
        image !== null ? (
            <Image
                media={image}
                className={classNames([styles.image, imageClassName])}
                pictureClassName={classNames([styles.picture, pictureClassName])}
            />
        ) : null;
    return (
        <animated.div
            className={classNames([
                styles.container,
                {
                    [styles.invert]: invert,
                    [styles.hasImage]: image !== null,
                },
                className,
            ])}
            data-theme={theme}
            style={withTransition ? containerSpring : null}
        >
            <div className={classNames([styles.inner, innerClassName])}>
                {image !== null && url !== null ? (
                    <a href={url} target="_blank" rel="noreferrer" className={styles.link}>
                        {imageElement}
                    </a>
                ) : (
                    imageElement
                )}
                <animated.div className={classNames([styles.content, contentClassName])}>
                    {url !== null ? (
                        <a href={url} target="_blank" rel="noreferrer" className={styles.link}>
                            {label}
                        </a>
                    ) : (
                        label
                    )}
                </animated.div>
                {callToAction !== null ? (
                    <div className={classNames([styles.callToAction, callToActionClassName])}>
                        {isValidElement(callToAction) ? (
                            callToAction
                        ) : (
                            <CallToAction url={url} {...callToAction} />
                        )}
                    </div>
                ) : null}
                {children}
            </div>
        </animated.div>
    );
}
export default PromotionCard;
